import { useQuery } from '@tanstack/react-query';
import {
  goodsService,
  type GoodsDiscountGroupItem,
  type GoodsDiscountGroup,
} from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';
import { useMemo } from 'react';
import { isNotNil } from 'shared/src/utils';

export const useApplyDiscounts = (params: {
  checked: GoodsDiscountGroupItem[];
  groups: GoodsDiscountGroup[];
}) => {
  const goodsSno = useGoodsSno();
  const checkedList = useMemo(() => {
    const checkedKeys = new Set(params.checked.map(item => item.key));

    return params.groups.flatMap(group =>
      group.items
        .filter(item => checkedKeys.has(item.key))
        .filter(item => isNotNil(item.detail))
        .map(item => ({
          group_type: group.group_type,
          sno: item.detail!.sno,
          item_key: item.key,
        })),
    );
  }, [params.groups, params.checked]);

  return useQuery({
    queryKey: queryKey.applyDiscounts(
      goodsSno,
      checkedList.map(key => `${key.sno}-${key.group_type}`),
    ),
    queryFn: () =>
      goodsService.postApplyDiscounts(goodsSno, {
        discount_groups: checkedList.map(checked => ({
          group_type: checked.group_type,
          sno: checked.sno,
          item_key: checked.item_key,
        })),
      }),
  });
};
